import { render, staticRenderFns } from "./DecontareDetails.vue?vue&type=template&id=96d16c9a&scoped=true"
import script from "./DecontareDetails.vue?vue&type=script&lang=js"
export * from "./DecontareDetails.vue?vue&type=script&lang=js"
import style0 from "./DecontareDetails.vue?vue&type=style&index=0&id=96d16c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d16c9a",
  null
  
)

export default component.exports